import React from 'react';

import { FileUploadWizard, FileUploadWizardProps } from '../FileUploadWizard';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';

export const BuyerFileUploadWizard: React.FC<Omit<FileUploadWizardProps, 'residentialUnitId'>> = (props) => {
    const residentialUnitId = useSelector((state: IState) => state.buyer.permissions!.residentialUnitId);
    return <FileUploadWizard residentialUnitId={residentialUnitId} {...props} />;
};

export default FileUploadWizard;
